<ul class="explore">

  <li
    class="explore__item"
    routerLink="/explore"
    [routerLinkActive]="'explore__item--active'"
    [routerLinkActiveOptions]="{ exact: true }">
      <div class="explore__image cat-all"></div>
      <div class="text-12">All Categories</div>
  </li>

  <li
    class="explore__item"
    *ngFor="let category of baseAnatomyCategories"
    [routerLink]="['/view']"
    [queryParams]="{'id': category.id, 'type':'module'}"
    [routerLinkActive]="'explore__item--active'">
      <div class="explore__image" [ngClass]="category.image"></div>
      <div class="text-12">{{ category.title }}</div>
  </li>

  <li
    class="explore__item"
    *ngFor="let category of categories"
    [routerLink]="['/explore', category.tag]"
    [routerLinkActive]="'explore__item--active'">
      <div class="explore__image" [ngClass]="category.image"></div>
      <div class="text-12">{{ category.title }}</div>
  </li>
  
</ul>